module.exports = __webpack_public_path__ + "static/d30bef1d.stock2.png";